import { render, staticRenderFns } from "./SurveyShowDetailsTab.vue?vue&type=template&id=c4bd8f26"
import script from "./SurveyShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./SurveyShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports